import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default CScrollToTop;
